import { action }          from 'mobx';
import { computed }        from 'mobx';
import { makeObservable }  from 'mobx';
import { observable }      from 'mobx';
import React               from 'react';
import AbstractModelXStore from './AbstractModelXStore';

type ContextMenu = {
	cardId: id | null;
	visible: boolean;
	x: number;
	y: number;
}

export default class InterventionPlanningCardsStore extends AbstractModelXStore {

	@observable
	private _contextMenu: ContextMenu = { cardId: null, visible: false, x: 0, y: 0, };

	@observable
	private _isDragging = false;

	@observable
	private _selectedCards: id[] = [];

	@observable
	private _selectionModeIsActivated = false;

	public constructor() {
		super();
		makeObservable(this);
	}

	public closeContextMenu() {
		this.setContextMenu({ cardId: null, visible: false, x: 0, y: 0 });
	}

	public deactivateSelectionMode() {
		this.setSelectionModeIsActivated(false);
		this.setSelectedCards([]);
	}

	public handleCardLongPress(cardId: id, isCardSelected: boolean) {
		if (!this.selectionModeIsActivated && !this.isDragging) {
			// Active le mode sélection et sélectionne la carte
			this.setSelectionModeIsActivated(true);
			this.setSelectedCards([cardId]);
		} else if (isCardSelected) {
			// Désactive le mode sélection si carte déjà sélectionnée
			this.deactivateSelectionMode();
		}
	}

	public handleCardSelect(cardId: id) {
		if (!this.selectionModeIsActivated){
			return;
		}

		const isAlreadySelected = this.selectedCards.includes(cardId);
		const newSelected = isAlreadySelected ? this.selectedCards.filter(id => id !== cardId) : [ ...this.selectedCards, cardId ];

		this.setSelectedCards(newSelected);

		if (newSelected.length === 0) {
			this.setSelectionModeIsActivated(false);
		}
	}

	public handleRightClick(event: React.MouseEvent, cardId: id) {
		this.setContextMenu({ cardId: cardId, visible: true, x: event.clientX, y: event.clientY, });
	}

	@action
	public setContextMenu(contextMenu: ContextMenu) {
		this._contextMenu = contextMenu;
	}
	
	@action
	public setIsDragging(value: boolean) {
		this._isDragging = value;
	}

	@action
	public setSelectedCards(selectedCards: id[]) {
		this._selectedCards = selectedCards;
	}

	@action
	public setSelectionModeIsActivated(value: boolean) {
		this._selectionModeIsActivated = value;
	}

	@computed
	public get contextMenu() {
		return this._contextMenu;
	}

	@computed
	public get isDragging() {
		return this._isDragging;
	}

	@computed
	public get selectedCards() {
		return this._selectedCards;
	}

	@computed
	public get selectionModeIsActivated() {
		return this._selectionModeIsActivated;
	}
}